import { EntityDescriptor } from '../business-logic';
import { bookingSchema } from '../schemas/booking';

export const bookingEntity: EntityDescriptor = {
	booking: {
		migrationStrategies: {
			1: function (oldDoc: any) {
				// migration to rxdb 12
				return oldDoc;
			},
			2: function (oldDoc: any) {
				// remove isPaid and add paymentState instead
				return null;
			},
			3: function (oldDoc: any) {
				// add additionalProperty field to allow extra fields from backend
				return oldDoc;
			},
			4: function (oldDoc: any) {
				/**
				 * New fields added:
				 *  * bookingLegId
				 * */
				return oldDoc;
			},
			5: function (oldDoc: any) {
				// bookingCode added
				oldDoc.bookingCode = oldDoc.bookingCode ?? '';

				return oldDoc;
			},
		},
		schema: bookingSchema,
	},
};
